import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./PopupBox.scss"

import dataJSON from "../../api/Story.json"

class PopupBox extends Component {
  constructor(props) {
    super();
    this.state = {}
    this.closeStory = this.closeStory.bind(this);
  }
  closeStory() {
    push("Read_More_Closed", "סיפור בלי כיסוי");
    this.props.showStory(false);
  }
  render() {
    return (
      <div>
        <div className={`popupfade${(this.props.storyData ? " active" : "")}`}></div>
        <section className={`section section-popup${(this.props.storyData ? " active" : "")}`}>
          <div className="padding">
            <div className="container">
              <div className="close" onClick={this.closeStory}></div>
              <div className="headline">
                <div className="head">
                  {dataJSON.headline}
                </div>
                <div className="desc" dangerouslySetInnerHTML={{__html: dataJSON.desc}}>
                </div>
                <div className="text">
                  <div className="wrapper">
                    <img src="./static/images/article/1.jpg" alt="" />
                    <p>שבט קרדשיאן־ג'נר חתום על לא מעט מהטרנדים הבולטים בתחום הטיפוח בשנים האחרונות. זה לא יהיה מוגזם לומר שהנוכחות הוויראלית של בנות המשפחה סימנה עידן חדש של חשיפה - עידן בו לא ממש משנה מה את עושה או איך את מרגישה אלא האופן שבו את מציגה את עצמך לקהל.</p>
                    <p>כתגובת נגד לעידן הרשתות החברתיות והחשיפה האדירה שאנחנו חיים בה, התפתחו לא מעט מגמות של כיסוי: שיטות איפור שמטשטשות את המראה הטבעי וחושפות מראה זוהר ומחוטב יותר, תוספות שיער שיתמכו במה שחנן הטבע, וכמובן - שלל פילטרים שיטשטשו את מה שעובר על העור שלך באמת.</p>
                    <p>השנה האחרונה סימנה תפנית חדה בכל מה שקשור למגמות הכיסוי. לאחר תקופה ארוכה בה עודדו אותנו להרגיש מועצמות על ידי הצללות כבדות, איפור מודגש והארות דרמטיות, יש גל חדש שסוחף לכיוון לגמרי אחר: אתרי היופי סימנו את מות ה"קונטורינג" האגרסיבי (שיטת איפור המתבססת על הצללות המחטבות את הפנים) והכריזו על ה"נון־קונטורינג" כדבר הגדול הבא.</p>
                    <p>את ניצני הגל היה ניתן לאתר על מסלולי התצוגות הנחשבים, כשעוד ועוד בתי אופנה קידמו את מראה ה"איפור־ללא־איפור". גם בשבוע הקוטור הפריזאי האחרון, שנחשב לדובדבן שבקצפת התעשייה, אפשר היה לראות אימוץ של המראה הטבעי בתצוגות נחשבות כמו זו של ג'יאמבטיסטה ואלי, ג'יבנשי ואלברטה פראטי.</p>

                    <img src="./static/images/article/2.jpg" alt="" />
                    <h4>Come as you are</h4>
                    <p>עלייתו המחודשת של מראה האיפור הטבעי קשורה במגמה נוספת שמעסיקה בימים אלו את עולם האופנה: אג'נדת הייצוגים המגוונים - זו שמאמינה כי אין מראה אחד "נכון" &nbsp;או "טרנדי", הפכה ללוהטת במיוחד. כתוצאה מכך, ניתנת במה רחבה יותר למראות מגוונים - מראות שמפסיקים למלא את המשבצת המוכרת של עור אחיד ומטופל מאוד שנראה נטול רבב.</p>
                    
                    <img src="./static/images/article/3.jpg" alt="" />
                    <p><strong>רגע, אבל איך מתרגמים את זה לחיי היומיום?</strong></p>
                    <p>מטרתה של מלאכת איפור טובה היא לאפשר לנו להישיר מבט אוהב יותר כלפי המראה. מבט שלא מגלה מישהי אחרת אלא את עצמינו בגרסת הנטורל. בדיוק עבור המטרה הזו נולד המייק אפ Even Better&trade; Glow Light Reflecting SPF15&nbsp;של קליניק. מצד אחד, הוא מאפשר להשיג מראה עור אחיד וזוהר באופן מיידי, ומצד שני הוא לא רק מכסה את הפיגמנטציה, אלא גם מטפל בכתמים הקיימים ומשפר את מרקם העור בטווח הארוך. התוצאה הסופית היא מראה טבעי, נקי, קורן והכי חשוב &ndash; לא מתאמץ. Come as you are, כבר אמרנו?</p>
                    <div className="virtualHeight"></div>
                  </div>
                </div>
                <div className="button" onClick={this.closeStory}>
                  <div className="button-text">
                    סגרי
                </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PopupBox;



// WEBPACK FOOTER //
// ./src/Components/PopupBox/PopupBox.js